<template>
    <p-secure require-admin>
        <p-form ref="form" @submit="onSubmit">
            <div class="container-fluid content-wrapper" v-if="webOrder">
                <b-row class="content-heading">
                    <b-col>
                        <div>Web Order Details</div>
                    </b-col>
                    <b-col cols="auto" class="ms-auto">
                        <p-button
                            :disabled="isReadOnly"
                            variant="primary"
                            :is-busy="isBusy || isRefreshBusy"
                            type="submit">
                            Save
                        </p-button>
                    </b-col>
                </b-row>
                <p-card>
                    <b-row class="mb-3" style="margin-left: 0.25rem; margin-right: 0.25rem;">
                        <b-col class="p-3 text-center" style="background-color: #C2CBD6;">
                            <span style="font-size: 1.2rem; color: #000000;">
                                <span class="ms-5">Order Number: 
                                    <span style="font-weight: bold;">{{ webOrder.name }}</span>
                                </span>
                                <span class="ms-5">Order Date: 
                                    <span style="font-weight: bold;">{{ datetimeToLocalTimeFormatter(webOrder.createDate) }}</span>
                                </span>
                                <span class="ms-5">Last Update: 
                                    <span style="font-weight: bold;">{{ datetimeToLocalTimeFormatter(webOrder.lastUpdateDate) }}</span>
                                </span>
                            </span>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col>
                            <div class="mb-2">
                                <h4>
                                    Order Status:
                                    {{ webOrder.webOrderStatus }}
                                    <b-overlay :show="isBusy || isRefreshBusy"
                                       rounded
                                       opacity="0.5"
                                       spinner-small
                                       spinner-variant="primary"
                                       class="d-inline-block">
                                    <b-dropdown
                                        class="ms-2"
                                        text="Close Order"
                                        variant="danger"
                                        :disabled="isReadOnly 
                                            || webOrder.webOrderStatus.toLowerCase() == 'complete' 
                                            || webOrder.webOrderStatus.toLowerCase() == 'cancelled' 
                                            || webOrder.webOrderStatus.toLowerCase() == 'completed at register'">
                                        <b-dropdown-item @click="handleCancelOrder('cancelOrder')">Cancel Order</b-dropdown-item>
                                        <b-dropdown-item 
                                            :disabled="webOrder.webOrderStatus.toLowerCase() == 'partial' 
                                                || webOrder.webOrderStatus.toLowerCase() == 'backordered' 
                                                || webOrder.webOrderStatus.toLowerCase() == 'failed' 
                                                || webOrder.webOrderStatus.toLowerCase() == 'partial/backordered'"
                                            @click="handleCancelOrder('completeAtRegister')">Completed at Register
                                        </b-dropdown-item>
                                    </b-dropdown>
                                    </b-overlay>
                                    <p-button class="ms-2" v-if="webOrder.webOrderStatus.toLowerCase() == 'cancelled' || webOrder.webOrderStatus.toLowerCase() == 'completed at register'"
                                        @click="handleReopen"
                                        :is-busy="isBusy || isRefreshBusy"
                                        :disabled="isReadOnly">
                                        Reopen
                                    </p-button>
                                </h4>
                            </div>
                        </b-col>
                    </b-row>
                    <b-row cols="1" cols-sm="2" cols-lg="3">
                        <b-col>
                            <p-card>
                                <div style="height: 175px;">
                                    <b-row>
                                        <b-col>
                                            <strong>Payment Details</strong>
                                        </b-col>
                                    </b-row>
                                    <b-row>
                                         <b-col>
                                            <span v-for="paymentMethod in webOrder.paymentMethods"
                                                :key="paymentMethod.saleTenderId">
                                                <div style="padding-bottom: 7px;">
                                                    <b-row>
                                                        <b-col>
                                                            <span v-if="paymentMethod.isGuarantee">
                                                                Rental Guarantee Tender:
                                                            </span>
                                                            <span v-else>
                                                                Payment:
                                                            </span>
                                                            <span style="display: inline-flex; align-items: center;">
                                                                {{ paymentMethod.paymentMethodName }}
                                                                <div v-if="(webOrder.webOrderStatus.toLowerCase() === 'open')
                                                                    || (webOrder.webOrderStatus.toLowerCase() === 'failed' && webOrder.saleShipments.length == 0)">
                                                                    <ARAccountsModal
                                                                        :customer="webOrder.customer"
                                                                        :web-order="webOrder"
                                                                        @addaccount="(e) => webOrderPaymentMethod(e, paymentMethod)"
                                                                        :payment-method="paymentMethod"
                                                                        :is-busy="isBusy || isRefreshBusy"
                                                                        class="ms-2"
                                                                        :disableEditButton="isReadOnly"
                                                                    />
                                                                </div>
                                                            </span>
                                                            
                                                            <span style="display: inline-flex; align-items: center;" 
                                                                v-if="(webOrder.webOrderStatus.toLowerCase() === 'open' && paymentMethod.isDCAccount
                                                                || (webOrder.webOrderStatus.toLowerCase() === 'failed' && webOrder.saleShipments.length == 0 && paymentMethod.isDCAccount))">
                                                                <DepartmentChargeModal
                                                                    :paymentMethod="paymentMethod"
                                                                    @loadData="loadData"
                                                                    :is-web-order-busy="isBusy || isRefreshBusy"
                                                                    @save="saveDCPromptDetails"
                                                                />
                                                            </span>  
                                                            
                                                            <b-row v-if="paymentMethod.isARAccount">
                                                                <b-col >
                                                                    Account Name: {{ paymentMethod.accountNumber }} {{ paymentMethod.giftCardNumber }}<br />
                                                                    Agency Name: {{  paymentMethod.agencyName }}
                                                                </b-col>
                                                            </b-row>
                                                            <span v-if="(paymentMethod.isARAccount || paymentMethod.isCCAccount) && !paymentMethod.isAccountValid"
                                                                style="color: red; margin-top: -5px;">
                                                                    {{ paymentMethod.paymentMethodName }} {{ paymentMethod.accountNumber }} {{ paymentMethod.agencyName }} is invalid!
                                                            </span>
                                                            <span v-else-if="paymentMethod.isDCAccount && !paymentMethod.isAccountValid"
                                                                style="color: red; margin-top: -5px;">
                                                                Department Charge details are missing!
                                                            </span>
                                                            <span v-if="paymentMethod.isTaxExempt"
                                                                 style="color: red;">TAX EXEMPT
                                                            </span>
                                                        </b-col>
                                                    </b-row>
                                                </div>                                            
                                            </span>                                    
                                        </b-col>
                                    </b-row>
                                </div>
                            </p-card>
                        </b-col>
                        <b-col>
                            <p-card>
                                <div style="height: 175px;">
                                    <span>
                                        <strong>Customer</strong><br />
                                        {{ webOrder.customer.firstName }}
                                        {{ webOrder.customer.lastName }}<br />
                                        <span v-if="webOrder.customer.email">{{ webOrder.customer.email }} <br/></span>
                                        <span v-if="webOrder.customer.phone.number">
                                            {{ phoneFormatter(webOrder.customer.phone) }}
                                            <br/>
                                        </span>
                                        <span v-if="webOrder.customer.number">
                                            {{ webOrder.customer.number }}
                                        </span>
                                        <p-button
                                            class="ms-1"
                                            v-b-modal.editCustomer
                                            :disabled="isReadOnly || webOrder.webOrderStatus.toLowerCase() != 'open' || isBusy"
                                            no-border
                                            :is-busy="isBusy || isRefreshBusy">
                                                <i class="fas fa-edit" />
                                        </p-button>
                                        <br />
                                        <p-feature-flag name="Customer Profile">
                                            <b v-if="!webOrder.customer.isActive" style="color:red;">Customer is inactive</b>
                                        </p-feature-flag>
                                        <br />
                                        <span v-if="webOrder.customer.hasOutstandingRentals" style="color:red;">
                                            Customer has outstanding rentals
                                        </span>
                                    </span>
                                </div>
                            </p-card>
                        </b-col>
                        <b-col>
                            <p-card>
                                <div style="height: 175px;">
                                    <p-address-input
                                        :key="webOrder.name"
                                        v-model="webOrder.shippingAddress"
                                        :disabled="isReadOnly || webOrder.webOrderStatus.toLowerCase() == 'complete' || webOrder.webOrderStatus.toLowerCase() == 'cancelled' || isBusy"
                                        text-area
                                        label="Shipping Address"
                                        :is-busy="isBusy || isRefreshBusy"
                                        @updateShipping="onSubmit">
                                    </p-address-input>
                                    <b-row>
                                        <b-col>
                                            <p-select
                                                label="Shipping Method"
                                                data-type="shippingCodes"
                                                v-model="webOrder.shipCodeId"
                                                :disabled="isReadOnly || webOrder.webOrderStatus.toLowerCase() == 'complete' || webOrder.webOrderStatus.toLowerCase() == 'cancelled' || isBusy"
                                                :filter="shippingCodeFilter"
                                            />
                                        </b-col>
                                        <b-col>
                                            <p-select
                                                label="Fulfillment Location"
                                                data-type="locations"
                                                v-model="webOrder.fulfillmentLocationId"
                                                :disabled="isReadOnly || isBusy || webOrder.webOrderStatus.toLowerCase() != 'open'"
                                                :filter="fulfillmentLocationFilter"
                                            />
                                        </b-col>
                                    </b-row>
                                </div>
                            </p-card>
                        </b-col>
                    </b-row>
                    <p-card>
                        <b-row>
                            <b-col>
                                <p-card>
                                    <h4>
                                        Internal Order Fulfillment Notes
                                        <span
                                            class="text-normal text-sm" v-if="webOrder.internalOrderNote.noteId">
                                            Last updated
                                            {{
                                                webOrder.internalOrderNote.modifiedDate == null
                                                    ? 'unknown'
                                                    : datetimeToLocalTimeFormatter(webOrder.internalOrderNote.modifiedDate).replace(', ', ' at ')
                                            }}
                                            by
                                            {{
                                                webOrder.internalOrderNote.userId == null
                                                    ? 'Unknown'
                                                    : webOrder.internalOrderNote.user.displayName
                                            }}.
                                        </span>
                                    </h4>
                                    <p-text-area
                                        :disabled="isReadOnly"
                                        :placeholder="'Comments written here are not visible to the customer'"
                                        v-model="webOrder.internalOrderNote.text"
                                    />
                                </p-card>
                            </b-col>
                            <b-col>
                                <p-card>
                                    <h4>
                                        Internal Customer Notes
                                    </h4>
                                    <p-text-area
                                        v-model="webOrder.internalCustomerNote"
                                        :disabled="true"
                                    />              
                                </p-card>
                            </b-col>                             
                        </b-row>
                    </p-card>
                    <p-card v-if="webOrder.webOrderStatus.toLowerCase() != 'open' 
                        && webOrder.webOrderStatus.toLowerCase() != 'complete' 
                        &&  webOrder.webOrderStatus.toLowerCase() != 'cancelled' 
                        &&  webOrder.webOrderStatus.toLowerCase() !=  'completed at register'">
                        <b-row class="mb-2">
                            <b-col cols="auto">
                                <h4>Status: {{ webOrder.webOrderStatus }}</h4>
                            </b-col>
                            <b-col cols="auto">
                                <h4>Shipping Method: {{ webOrder.shipmentMethod }}</h4>
                            </b-col>                            
                        </b-row>
                        <b-row class="mb-2">
                            <b-col cols="12" class="d-flex">
                                <p-button
                                    variant="primary"
                                    :disabled="isReadOnly || noQtyToFill() || !webOrder.customer.isActive || !webOrder.allPaymentMethodsValid || isBusy || !isWorkable"
                                    @click="validateWorkOrder()"
                                    :is-busy="isBusy || isRefreshBusy">
                                    Work Order
                                </p-button>
                                <template v-if="canAddProducts">
                                    <ProductMultiSelectQuickSearch
                                        is-active-filter
                                        include-products
                                        include-terms
                                        icon-plus
                                        label="Add Product(s)"
                                        title="Add Product to Web Order"
                                        name="AddToWebOrder"
                                        @selections="addSelectedItems"
                                        fieldSet="webOrderFields"
                                        class="ms-2"
                                        :is-busy="isBusy || isRefreshBusy"
                                        :disableAddButton="isReadOnly"
                                    />
                                </template>
                                <p-button
                                    class="ms-2"
                                    variant="outline-primary"
                                    :disabled="webOrder.products.length <= 0"
                                    @click="printPicklist()"
                                    :is-busy="isBusy">
                                        Print Picklist
                                </p-button>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col>
                                <p-table
                                    :items="webOrder.partialSales"
                                    :fields="partialSaleFields"
                                    :enable-row-selection="false">
                                    <template #row-details="row">
                                        <div v-if="row.item.comments" class="">
                                            Comments:
                                            {{ row.item.comments }}
                                        </div>
                                    </template>
                                    <template v-slot:cell(retailPrice)="{ value, item }">
                                        <div v-if="item.isOnSale">
                                            <s>{{ value }}</s>
                                            <div>{{ currencyFormatter(item.itemPrice) }}
                                            </div>
                                        </div>
                                        <div v-else>{{ value }}</div>
                                    </template>
                                    <template v-slot:cell(taxTotal)="{ value, item }">
                                        <div>
                                            {{ currencyFormatter(calcExtTaxPartialSale(item)) }}
                                        </div>
                                    </template>
                                </p-table>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col cols="12" lg="5">
                                <p-text-area
                                    label="Shipping Instructions"
                                    v-model="webOrder.shippingInstructions"
                                    :disabled="true"
                                />
                                <p-text-area
                                    label="Special Comments"
                                    v-model="webOrder.specialComments"
                                    :disabled="true"
                                />
                            </b-col>
                        </b-row>
                    </p-card>
                    <div v-if="webOrder.webOrderStatus.toLowerCase() != 'open'">
                        <p-card
                            v-for="saleShipment in webOrder.saleShipments"
                            :key="saleShipment.saleFulfillmentId + '-' + (saleShipment.refundOfSaleFulfillmentId || 0)"
                            :class="saleShipment.refundOfSaleFulfillmentId ? 'refund-card ms-4' : 'shipment-card'">
                            <b-row class="mb-2">
                                <b-col cols="auto" v-if="saleShipment.refundOfSaleFulfillmentId">
                                    <span class="badge bg-danger me-2">Refunded</span>
                                </b-col>
                                <b-col cols="auto">
                                    <h4>Shipment #: {{ saleShipment.saleFulfillmentName }}</h4>
                                </b-col>
                                <b-col cols="auto">
                                    <h4>Shipment Date: {{ dateFormatter(saleShipment.processDate) }}</h4>
                                </b-col>
                                <b-col cols="auto">
                                    <h4>Shipping Method: {{ saleShipment.shippingMethod }}</h4>
                                </b-col>
                            </b-row>
                            <b-row v-if="!saleShipment.refundOfSaleFulfillmentId" class="mb-2">
                                <b-col>
                                    <p-button
                                        variant="outline-primary"
                                        @click="exportShipment(saleShipment, 1)"
                                        :is-busy="isPackingBusy"
                                        >Packing List</p-button
                                    >
                                    <p-button
                                        variant="outline-primary"
                                        class="ms-2"
                                        @click="exportShipment(saleShipment, 0)"
                                        :is-busy="isReceiptBusy"
                                        ><i class="fas fa-print"></i>
                                        Receipt</p-button
                                    >
                                    <p-button
                                        v-if="shipmentHasRefundable(saleShipment)"
                                        variant="outline-danger"
                                        class="ms-2"
                                        @click="openRefundModal(saleShipment)"
                                        :is-busy="isRefundBusy"
                                        ><i class="fas fa-rotate-left"></i>
                                        Refund Shipment</p-button
                                    >
                                </b-col>
                            </b-row>
                            <b-row>
                                <b-col>
                                    <p-table
                                        :items="
                                            saleShipment.saleShippingProducts
                                        "
                                        :fields="SaleShipmentsFields"
                                        :enable-row-selection="false"
                                        :row-class="refundRowClass"
                                    >
                                        <template #row-details="row">
                                            <div
                                                v-if="row.item.comments"
                                                class=""
                                            >
                                                Comments:
                                                {{ row.item.comments }}
                                            </div>
                                        </template>
                                        <template
                                            v-slot:cell(retailPrice)="{
                                                value,
                                                item
                                            }"
                                        >
                                            <div v-if="item.isOnSale">
                                                <s>{{ value }}</s>
                                                <div>
                                                    {{
                                                        currencyFormatter(
                                                            item.itemPrice
                                                        )
                                                    }}
                                                </div>
                                            </div>
                                            <div v-else>{{ value }}</div>
                                        </template>
                                        <template v-slot:cell(description)="{ item }">
                                            {{ item.description }}
                                            <div
                                                v-if="item.refundedQty > 0 && item.refundedQty < item.shippedQty"
                                                class="text-warning small"
                                            >
                                                {{ item.refundedQty }} of {{ item.shippedQty }} refunded
                                            </div>
                                        </template>
                                    </p-table>
                                </b-col>
                            </b-row>
                            <b-row>
                                <b-col cols="12" lg="5">
                                    <p-text-area
                                        label="Shipping Instructions"
                                        v-model="webOrder.shippingInstructions"
                                        :disabled="true"
                                    />
                                    <p-text-area
                                        label="Special Comments"
                                        v-model="webOrder.specialComments"
                                        :disabled="true"
                                    />
                                </b-col>
                                <b-col class="ms-auto" cols="12" lg="5">
                                    <b-row>
                                        <b-col cols="9">
                                            <strong>Shipment Subtotal:</strong
                                            ><br /><br />
                                            <strong>Shipping & Handling:</strong
                                            ><br /><br />

                                            <strong>Shipping Tax:</strong
                                            ><br /><br />
                                            <strong>Extended Tax Total:</strong
                                            ><br /><br />
                                            <strong>Grand Total:</strong
                                            ><br /><br />
                                        </b-col>
                                        <b-col cols="3" class="text-end">
                                            <strong>{{
                                                currencyFormatter(
                                                    saleShipment.subTotal
                                                )
                                            }}</strong
                                            ><br /><br />
                                            <strong>{{
                                                currencyFormatter(
                                                    saleShipment.shippingTotal
                                                )
                                            }}</strong
                                            ><br /><br />
                                            <strong>{{
                                                currencyFormatter(
                                                    saleShipment.shippingTax
                                                )
                                            }}</strong
                                            ><br /><br />
                                            <strong>{{
                                                currencyFormatter(
                                                    saleShipment.extendedTaxTotal
                                                )
                                            }}</strong
                                            ><br /><br />
                                            <strong>{{
                                                currencyFormatter(
                                                    saleShipment.grandTotal
                                                )
                                            }}</strong
                                            ><br /><br />
                                        </b-col>
                                    </b-row>
                                </b-col>
                            </b-row>
                        </p-card>
                    </div>
                    <p-card>
                        <b-row class="mb-2">
                            <b-col cols="auto">
                                <h4>
                                    Original Order:
                                    {{ dateFormatter(webOrder.createDate) }}
                                </h4>
                            </b-col>
                            <b-col cols="auto">
                                <h4>
                                    Shipping Method:
                                    {{ webOrder.originalShipmentMethod }}
                                </h4>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col v-if="webOrder.webOrderStatus.toLowerCase() == 'open'" class="d-flex mb-2" cols="12">
                                <p-button
                                    variant="primary"
                                    @click="validateWorkOrder()"
                                    :is-busy="isBusy || isRefreshBusy"
                                    :disabled="isReadOnly || !webOrder.allPaymentMethodsValid || !webOrder.customer.isActive || !isWorkable">
                                        Work Order
                                    </p-button>
                                <ProductMultiSelectQuickSearch
                                    is-active-filter
                                    include-products
                                    include-terms
                                    icon-plus
                                    label="Add Product(s)"
                                    title="Add Product to Web Order"
                                    name="AddToWebOrder"
                                    @selections="addSelectedItems"
                                    fieldSet="webOrderFields"
                                    class="ms-2 me-2"
                                    :is-busy="isBusy || isRefreshBusy"
                                    :disableAddButton="isReadOnly"
                                />
                                <p-button
                                    variant="outline-primary"
                                    :disabled="webOrder.products.length <= 0"
                                    @click="printPicklist()"
                                    :is-busy="isBusy">
                                        Print Picklist
                                </p-button>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col>
                                <p-table
                                    :items="webOrder.products"
                                    :fields="productFields"
                                    :enable-row-selection="false">
                                    <template #row-details="row">
                                        <div v-if="row.item.comments" class="">
                                            Comments:
                                            {{ row.item.comments }}
                                        </div>
                                    </template>
                                    <template v-slot:cell(retailPrice)="{ value, item }">
                                        <div v-if="item.isOnSale">
                                            <s>{{ item.isPriceOverride ? currencyFormatter(item.productInventoryRetailPrice) : value }}</s>
                                            <p-number
                                                input-type="money"
                                                rules="min_value:0"
                                                push-right
                                                compact-format
                                                v-model="item.itemPrice"
                                                :disabled="webOrder.webOrderStatus.toLowerCase() !== 'open' || item.shippedQty > 0 || isReadOnly"
                                                @change="item.isPriceOverride = true"
                                            />
                                        </div>
                                        <div v-else>
                                            <s v-if="item.isPriceOverride">{{ currencyFormatter(item.productInventoryRetailPrice) }}</s>
                                            <p-number
                                                input-type="money"
                                                rules="min_value:0"
                                                push-right
                                                compact-format
                                                v-model="item.retailPrice"
                                                :disabled="webOrder.webOrderStatus.toLowerCase() !== 'open' || item.shippedQty > 0 || isReadOnly"
                                                @change="item.isPriceOverride = true"
                                            />
                                        </div>
                                    </template>
                                </p-table>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col cols="12" lg="5">
                                <p-text-area
                                    label="Shipping Instructions"
                                    v-model="webOrder.shippingInstructions"
                                    :disabled="true"
                                />
                                <p-text-area
                                    label="Special Comments"
                                    v-model="webOrder.specialComments"
                                    :disabled="true"
                                />
                            </b-col>
                            <b-col class="ms-auto" cols="12" lg="5">
                                <b-row>
                                    <b-col cols="9">
                                        <strong>Order Total:</strong
                                        ><br /><br />
                                        <strong>Shipping & Handling:</strong
                                        ><br /><br />
                                        <strong>Shipping Tax (estimated):</strong
                                        ><br /><br />
                                        <strong>Extended Tax Total (estimated):</strong
                                        ><br /><br />
                                        <strong>Grand Total:</strong
                                        ><br /><br />
                                    </b-col>
                                    <b-col cols="3" class="text-end">
                                        <strong>{{
                                            currencyFormatter(webOrder.subtotal)
                                        }}</strong
                                        ><br /><br />
                                        <strong>{{
                                            currencyFormatter(
                                                webOrder.shippingTotal
                                            )
                                        }}</strong
                                        ><br /><br />
                                        <strong>{{
                                            currencyFormatter(
                                                webOrder.shippingTax
                                            )
                                        }}</strong
                                        ><br /><br />
                                        <strong>{{
                                            currencyFormatter(
                                                webOrder.extendedTaxTotal
                                            )
                                        }}</strong
                                        ><br /><br />
                                        <strong>{{
                                            currencyFormatter(webOrder.total)
                                        }}</strong
                                        ><br /><br />
                                    </b-col>
                                </b-row>
                            </b-col>
                        </b-row>
                    </p-card>
                </p-card>
                <b-row>
                    <b-col class="mt-2 mb-2 text-center">
                        <p-button
                            :disabled="isReadOnly"
                            variant="primary"
                            :is-busy="isBusy  || isRefreshBusy"
                            type="submit">
                            Save
                        </p-button>
                    </b-col>
                </b-row>
                <p-modal
                    name="editCustomer"
                    label="Customer Name"
                    size="md"
                    no-close-on-backdrop
                    no-close-esc
                    @ok.prevent="handleAddCustomer"
                    @show="showModal"
                    ref="editCustomerModal"
                >
                    <template v-slot:default>
                        <p-form ref="formModal">
                            <div>
                                <b-row>
                                    <b-col>
                                        {{ webOrder.customer.firstName }}
                                        {{ webOrder.customer.lastName }}
                                        <span v-if="webOrder.customer.email"
                                            >{{ webOrder.customer.email }}
                                        </span>
                                        <span v-if="webOrder.customer.phone"
                                            >{{
                                                webOrder.customer.phone.number
                                            }}
                                        </span>
                                        <span v-if="webOrder.customer.number">{{
                                            webOrder.customer.number
                                        }}</span>
                                    </b-col>
                                </b-row>
                                <b-row class="mt-2">
                                    <b-col>
                                        <p-advanced-select
                                            label="Customer"
                                            data-type="customers"
                                            v-model="
                                                webOrder.customer.customerId
                                            "
                                            rules="required"
                                        />
                                    </b-col>
                                </b-row>
                            </div>
                        </p-form>
                    </template>
                </p-modal>
                <p-modal
                    name="workOrder"
                    label=""
                    size="xl"
                    hide-footer
                    no-close-on-backdrop
                    @show="showWorkOrderModal"
                    @hide="hideWorkOrderModal"
                    ref="workOrderModal"
                >
                    <template v-slot:modal-title>
                        <b-row class="mb-2">
                            <b-col cols="auto">
                                <strong>Order Date: </strong>{{ dateFormatter(webOrder.createDate) }}
                                <strong class="ms-2">Shipping Address: </strong> {{ addressFormatter(webOrder.shippingAddress) }}
                                <br />
                                <strong>Status: </strong>{{ webOrder.webOrderStatus }}
                                <strong>Shipping Method: </strong>{{ webOrder.shipmentMethod }}
                                <strong>Fulfillment Location: </strong>{{ webOrder.fulfillmentLocation }}
                                <br />
                                <strong>Tax Calculation Last Updated: </strong>
                                <span :class="{ redColor: webOrder.taxServiceLastUpdate == null }">
                                    {{
                                        webOrder.taxServiceLastUpdate == null
                                            ? 'Never'
                                            : datetimeToLocalTimeFormatter(webOrder.taxServiceLastUpdate)
                                    }}
                                </span>
                                <p-button v-if="webOrder.webOrderStatus.toLowerCase() == 'open' && !webOrder.isTaxExempt"
                                    class="s ms-2"
                                    variant="primary"
                                    @click="refreshAllTaxes"
                                    :is-busy="isBusy  || isRefreshBusy"
                                    :disabled="isReadOnly">
                                    Refresh All Taxes
                                </p-button>
                                <br />
                                <span v-if="webOrder.isTaxExempt"
                                    style="color: red;">Account is Tax Exempt
                                </span>
                            </b-col>
                        </b-row>
                    </template>
                    <template v-slot:default>
                        <p-form ref="formModal">
                            <div>
                                <b-row v-if="refreshIsBusy">
                                    <b-col>
                                        <p-table
                                            :items="workOrder.partialSales"
                                            :fields="workOrderFields"
                                            :enable-row-selection="false"
                                            ref="partialSalesTable">
                                            <template #row-details="row">
                                                <span>
                                                    <div v-if="row.item.comments" class="">
                                                        Comments: {{ row.item.comments }}
                                                    </div>
                                                    <div v-if="row.item.isSerialized || row.item.isRental" class="">
                                                        <br />
                                                        <p-table v-if="row.item.isSerialized"
                                                            :items="row.item.serialNumbers"
                                                            :fields="[
                                                                {
                                                                    key: 'label',
                                                                    tdClass:'text-end'
                                                                },
                                                                {
                                                                    key: 'serialNumber',
                                                                    tdClass:'text-start'
                                                                }
                                                            ]"
                                                            :enable-row-selection="false"
                                                            thead-class="d-none"
                                                            :show-record-count="false"
                                                            class="overflow-hidden no-top-border"
                                                            empty-text="">
                                                            <template v-slot:cell(label)="{}">
                                                                <strong>Serial Number:</strong>
                                                            </template>
                                                            <template v-slot:cell(serialNumber)="{ value, item }">
                                                                <p-input
                                                                    name="Serial Number"
                                                                    v-model="item.serialNumber"
                                                                    :rules="{
                                                                        required: true,
                                                                        max: { length: 25 },
                                                                        isUnique: {
                                                                            isUniqueValue: item.isUnique,
                                                                            message: 'This serial number is already in use for this order.'
                                                                        },
                                                                        'is-valid-serial-number': {
                                                                            isValidValue: item.isValid,
                                                                            message: item.serialMessage
                                                                        }
                                                                    }"
                                                                    @change="updateSerialValidation(row.item, value, item)"
                                                                    class="ms-3 tcw200"
                                                                    mode="lazy">
                                                                </p-input>
                                                            </template>
                                                        </p-table>
                                                        <p-table v-if="row.item.isRental"
                                                            :items="row.item.rentalXrefs"
                                                            :fields="[
                                                                {
                                                                    key: 'label',
                                                                    tdClass:'text-end'
                                                                },
                                                                {
                                                                    key: 'rentalXref',
                                                                    tdClass:'text-start'
                                                                }
                                                            ]"
                                                            :enable-row-selection="false"
                                                            thead-class="d-none"
                                                            :show-record-count="false"
                                                            class="overflow-hidden no-top-border"
                                                            empty-text="">
                                                            <template v-slot:cell(label)="{}">
                                                                <strong>Rental Xref:</strong>
                                                            </template>
                                                            <template v-slot:cell(rentalXref)="{ value, item }">
                                                                <p-input
                                                                    name="Rental Xref"
                                                                    v-model="item.rentalXref"
                                                                    :rules="{
                                                                        required: true,
                                                                        'xref-length': true,                                                             
                                                                        isUnique: {
                                                                            isUniqueValue: item.isUnique,
                                                                            message: 'This Xref is a duplicate of another Xref on this order.'
                                                                        },
                                                                        'is-valid-rental-xref': {
                                                                            isValidValue: item.isValid
                                                                        }
                                                                    }"
                                                                    @change="validateRentalXref(row.item, value, item)"
                                                                    class="ms-3 tcw200"
                                                                    mode="lazy">
                                                                </p-input>
                                                            </template>
                                                        </p-table>
                                                    </div>
                                                </span>
                                            </template>
                                            <template
                                                v-slot:cell(retailPrice)="{
                                                    value,
                                                    item
                                                }"
                                            >
                                                <div v-if="item.isOnSale">
                                                    <s>{{ value }}</s>
                                                    <div>
                                                        {{
                                                            currencyFormatter(
                                                                item.itemPrice
                                                            )
                                                        }}
                                                    </div>
                                                </div>
                                                <div v-else>{{ value }}</div>
                                            </template>
                                            <template
                                                v-slot:cell(shippedQty)="{
                                                    value,
                                                    item
                                                }"
                                            >
                                                <p-number
                                                    v-model.number="item.shippedQty"
                                                    @change="fulfilledQtyChanged($event, item)"
                                                    narrow-input
                                                    name="Fulfilled Qty"
                                                    input-type="integer"
                                                    :rules="getShippedQtyRules(item)"
                                                    compact-format
                                                >
                                                </p-number>
                                            </template>
                                            <template
                                                v-slot:cell(cancelledQty)="{
                                                    value,
                                                    item
                                                }"
                                            >
                                                <p-number
                                                    v-model.number="
                                                        item.cancelledQty
                                                    "
                                                    @change="
                                                        item.cancelledQty = zeroIfNullFormatter(
                                                            item.cancelledQty
                                                        )
                                                    "
                                                    input-type="integer"
                                                    name="Cancelled Qty"
                                                    narrow-input
                                                    :rules="
                                                        getCancelledQtyRules(
                                                            item
                                                        )
                                                    "
                                                    compact-format
                                                >
                                                </p-number>
                                            </template>
                                            <template
                                                v-slot:cell(tax)="{
                                                    value,
                                                    item
                                                }"
                                            >
                                                <p-number
                                                    :model-value="
                                                        item.manualOverrideUserInput
                                                    "
                                                    @change="
                                                        handleItemTaxOverride(
                                                            $event,
                                                            item
                                                        )
                                                    "
                                                    narrow-input
                                                    input-type="money"
                                                    name="Tax"
                                                    rules="min_value:0"
                                                    :disabled="
                                                        webOrder.isTaxExempt
                                                    "
                                                    compact-format
                                                >
                                                </p-number>
                                            </template>
                                            <template
                                                v-slot:cell(backorderedQty)="{
                                                    value,
                                                    item
                                                }"
                                            >
                                                <p-number
                                                    v-model.number="
                                                        item.backorderedQty
                                                    "
                                                    @change="
                                                        item.backorderedQty = zeroIfNullFormatter(
                                                            item.backorderedQty
                                                        )
                                                    "
                                                    input-type="integer"
                                                    name="Back Order Qty"
                                                    narrow-input
                                                    :rules="
                                                        getBackOrderQtyRules(
                                                            item
                                                        )
                                                    "
                                                    compact-format
                                                >
                                                </p-number>
                                            </template>
                                        </p-table>
                                    </b-col>
                                </b-row>
                                <b-row>
                                    <b-col cols="12" lg="5">
                                        <p-text-area
                                            label="Shipping Instructions"
                                            v-model="
                                                workOrderShippingInstructions
                                            "
                                            name="Shipping Instructions"
                                            :disabled="false"
                                        />
                                        <p-text-area
                                            label="Special Comments"
                                            v-model="workOrderSpecialComments"
                                            name="Special Comments"
                                            :disabled="false"
                                        />
                                    </b-col>
                                    <b-col class="ms-auto" cols="12" lg="5">
                                        <b-row>
                                            <b-col cols="9" lg="8" xl="9">
                                                <strong
                                                    >Shipment Subtotal:</strong
                                                ><br /><br />
                                                <strong
                                                    >Shipping &
                                                    Handling:</strong
                                                ><br /><br />
                                                <strong>Shipping Tax (estimated):</strong
                                                ><br /><br />
                                                <strong>Item Tax (estimated):</strong
                                                ><br /><br />
                                                <strong>Grand Total:</strong
                                                ><br /><br />
                                            </b-col>
                                            <b-col
                                                cols="3"
                                                lg="4"
                                                xl="3"
                                                class="text-end"
                                            >
                                                <strong>{{
                                                    currencyFormatter(
                                                        calcWorkOrderSubTotal
                                                    )
                                                }}</strong
                                                ><br /><br />
                                                <p-number
                                                    v-if="canAddShippingFee"
                                                    input-type="money"
                                                    name="shippingAndHandling"
                                                    v-model.number="
                                                        workOrderShippingFees
                                                    "
                                                    rules="min_value:0"
                                                    compact-format
                                                    class="mb-3"
                                                />
                                                <div v-else>
                                                    <strong>
                                                        N/A
                                                    </strong>
                                                    <br /><br />
                                                </div>
                                                <p-number
                                                    v-if="canAddShippingFee"
                                                    input-type="money"
                                                    name="Shipping Tax"
                                                    v-model.number="
                                                        workOrder.manualOverrideUserInput
                                                    "
                                                    @blur="
                                                        handleShippingTaxOverride(
                                                            $event,
                                                            workOrder
                                                        )
                                                    "
                                                    rules="min_value:0"
                                                    :disabled="
                                                        webOrder.isTaxExempt
                                                    "
                                                    compact-format
                                                    class="mb-3"
                                                />
                                                <div v-else>
                                                    <strong>
                                                        N/A
                                                    </strong>
                                                    <br /><br />
                                                </div>
                                                <strong>{{
                                                    currencyFormatter(
                                                        calcWorkOrderItemTaxTotal
                                                    )
                                                }}</strong
                                                ><br /><br />
                                                <strong>{{
                                                    currencyFormatter(
                                                        calcWorkOrderTotal
                                                    )
                                                }}</strong>
                                            </b-col>
                                        </b-row>
                                    </b-col>
                                </b-row>
                                <b-row class="mb-2" v-if="processFailed">
                                    <b-col>
                                        <span
                                            v-if="
                                                requestedAmount > approvedAmount
                                            "
                                            style="color:red"
                                            >Requested Amount
                                            {{
                                                currencyFormatter(
                                                    requestedAmount
                                                )
                                            }}
                                            is greater than the Authorized
                                            Amount
                                            {{
                                                currencyFormatter(
                                                    approvedAmount
                                                )
                                            }}
                                            (attempt #
                                            {{ failedAuthAttempts }})</span
                                        >
                                        <span v-else>
                                            <span
                                                v-if="failedAuthAttempts < 5"
                                                style="color:red"
                                                >Credit card processing has
                                                failed. Please cancel order or
                                                try again (attempt #
                                                {{ failedAuthAttempts }})</span
                                            >
                                            <span
                                                v-if="failedAuthAttempts >= 5"
                                                style="color:red"
                                                >Processing attempts exceeded.
                                                You may only process $0.00
                                                (attempt #
                                                {{ failedAuthAttempts }})</span
                                            >
                                        </span>
                                    </b-col>
                                </b-row>
                                <b-row v-if="workOrder.paymentMethod.isARAccount && !workOrder.paymentMethod.noLimit && workOrder.paymentMethod.availableFunds < calcWorkOrderTotal">
                                    <b-col class="text-end mb-2">
                                        <strong :class="{ 'text-danger': workOrder.paymentMethod.availableFunds < calcWorkOrderTotal }">
                                            Available Funds: {{ currencyFormatter(workOrder.paymentMethod.availableFunds) }}
                                        </strong>
                                    </b-col>
                                </b-row>                            
                                <b-row>
                                    <b-col>
                                        <p-button
                                            variant="danger"
                                            @click="processCancelShipment"
                                            :disabled="isReadOnly || !processFailed"
                                            :is-busy="isBusy  || isRefreshBusy"
                                            >Cancel Shipment</p-button
                                        >
                                        <p-button
                                            class="float-end"
                                            variant="primary"
                                            @mousedown.prevent
                                            @click="processWorkOrder"
                                            :disabled="disabledProcess"
                                            :is-busy="isBusy  || isRefreshBusy"
                                            >Process
                                            <strong>{{
                                                currencyFormatter(
                                                    calcWorkOrderTotal
                                                )
                                            }}</strong></p-button
                                        >
                                    </b-col>
                                </b-row>
                            </div>
                        </p-form>
                    </template>
                </p-modal>
                <p-modal
                    name="refund"
                    label="Refund Shipment"
                    size="lg"
                    no-close-on-backdrop
                    ref="refundModal"
                    @ok.prevent="processRefund"
                    ok-label="Process Refund"
                >
                    <template v-slot:default>
                        <p-form ref="refundForm">
                            <p-table
                                v-if="refundLines.length > 0"
                                :items="refundLines"
                                :fields="refundFields"
                                :enable-row-selection="false"
                            >
                                <template v-slot:cell(qty)="{ item }">
                                    <p-number
                                        v-model.number="item.qty"
                                        input-type="integer"
                                        narrow-input
                                        compact-format
                                        :rules="`min_value:0|max_value:${item.remaining}`"
                                        name="Refund Qty"
                                    />
                                </template>
                                <template v-slot:cell(amount)="{ item }">
                                    <p-number
                                        :model-value="refundAppliedAmount(item)"
                                        @change="onRefundAmountEntered($event, item)"
                                        input-type="money"
                                        narrow-input
                                        compact-format
                                        :rules="`min_value:0|max_value:${refundMaxAmount(item)}`"
                                        name="Amount"
                                    />
                                </template>
                                <template v-slot:cell(tax)="{ item }">
                                    <p-number
                                        :model-value="refundAppliedTax(item)"
                                        @change="onRefundTaxEntered($event, item)"
                                        input-type="money"
                                        narrow-input
                                        compact-format
                                        :rules="`min_value:0|max_value:${refundMaxTax(item)}`"
                                        name="Tax"
                                    />
                                </template>
                            </p-table>
                            <p v-else class="text-muted small mb-0">
                                No merchandise items remain to refund on this shipment.
                            </p>
                            <div v-if="!webOrder.isTaxExempt" class="text-end mt-2">
                                <p-button
                                    class="s"
                                    variant="primary"
                                    @click="refreshRefundTaxes"
                                    :is-busy="isRefundTaxBusy"
                                >
                                    Refresh All Taxes
                                </p-button>
                            </div>
                            <div v-if="refundShipment && refundShipment.canRefundShipping" class="mt-2">
                                <b-row>
                                    <b-col cols="6">
                                        <p-number
                                            label="Refund Shipping"
                                            input-type="money"
                                            v-model.number="refundShippingAmount"
                                            :rules="`min_value:0|max_value:${refundShipment.shippingTotal || 0}`"
                                            name="Refund Shipping"
                                            compact-format
                                        />
                                    </b-col>
                                    <b-col cols="6">
                                        <p-number
                                            label="Refund Shipping Tax"
                                            input-type="money"
                                            v-model.number="refundShippingTax"
                                            :rules="`min_value:0|max_value:${refundShipment.shippingTax || 0}`"
                                            name="Refund Shipping Tax"
                                            :disabled="webOrder.isTaxExempt"
                                            compact-format
                                        />
                                    </b-col>
                                </b-row>
                            </div>
                            <div class="text-end mt-2">
                                <strong>Refund total: {{ currencyFormatter(refundTotal) }}</strong>
                            </div>
                        </p-form>
                    </template>
                </p-modal>
            </div>
        </p-form>
    </p-secure>
</template>
<script>
import axios from 'axios';
import { downloadFileToBrowser } from '@/components/Common/BrowserDownload.js';
import ProductMultiSelectQuickSearch from '@/components/ProductMultiSelectQuickSearch.vue';
import NavigationGuard from '@/components/mixins/NavigationGuard.js';
import {
    phoneFormatter,
    currencyFormatter,
    roundingFormatter,
    bookVariantFormatter,
    dateFormatter,
    datetimeToLocalTimeFormatter
} from '@/components/Common/Formatters.js';
import { defineRule } from 'vee-validate';
import unionBy from 'lodash/unionBy';
import { addressFormatter } from '@/components/Common/Formatters.js';
import selectListOptionsDataContext from '@/services/selectListOptions.dataContext.js';
import RefundCalculations from '@/services/RefundCalculations.js';
import ARAccountsModal from './ARAccountsModal.vue';
import { useAppStateStore } from '@/stores/appState.js';
import { useSelectListsStore } from '@/stores/selectLists.js';
import DepartmentChargeModal from './DepartmentChargeModal.vue';

defineRule('exceed-shipped-qty', (value, [orderQty, cancelledQty]) => {
    return (
        -1 <
        (parseInt(orderQty) || 0) -
            (parseInt(value) || 0) -
            (parseInt(cancelledQty) || 0)
    ) || 'Work Order Qty exceeds Qty to Fill';
});
defineRule('exceed-cancelled-qty', (value, [orderQty, shippedQty]) => {
    return (
        -1 <
        (parseInt(orderQty) || 0) -
            (parseInt(shippedQty) || 0) -
            (parseInt(value) || 0)
    ) || 'Work Order Qty exceeds Qty to Fill';
});
defineRule('exceed-back-order-qty', (value, [orderQty, cancelledQty, shippedQty]) => {
    return (
        (parseInt(value) || 0) <=
        (parseInt(orderQty) || 0) -
            (parseInt(cancelledQty) || 0) -
            (parseInt(shippedQty) || 0)
    ) || 'Qty to Fill is met';
});
defineRule('is-valid-serial-number', (value, { isValidValue, message }) => {
    return (isValidValue == undefined || isValidValue) || message || 'Invalid serial number.';
});
defineRule('is-valid-rental-xref', (value, { isValidValue }) => {
    return (isValidValue == undefined || isValidValue) || 'Rental Xref is currently in use.';
});
defineRule('xref-length', (value) => {
    return (value.length === 12 || value.length === 20) || 'Xref must be exactly 12 or 20 characters.';
});

export default {
    mixins: [NavigationGuard],
    props: {
        id: String
    },
    data() {
        return {
            isBusy: false,
            isRefreshBusy:false,
            refreshIsBusy: true,
            // Field-level serial/xref validation busy flag. Kept separate from
            // isBusy so blurring a serial input (which fires its async validation)
            // doesn't disable the Process button mid-click — otherwise the first
            // click only blurs/validates the field and a second click is needed.
            isValidatingField: false,
            isReceiptBusy: false,
            isPackingBusy: false,
            isRefundBusy: false,
            refundShipment: null,
            refundLines: [],
            refundShippingAmount: 0,
            refundShippingTax: 0,
            isRefundTaxBusy: false,
            currentlySelectedLocationId: null,
            currentFulfillmentLocationId: null,
            webOrder: null,
            customerId: null,
            workOrder: {
                saleId: 0,
                name: 0,
                shippingTax: 0,
                shippingTaxOverrideId: null,
                shippingTaxOverride: null,
                shippingTotal: 0,
                itemTaxTotal: 0,
                total: 0,
                subTotal: 0,
                shippingInstructions: null,
                specialComments: null,
                saleFulfillmentId: 0,
                partialSales: [],
                isTaxExempt: false,
                paymentMethod: null,
            },
            workOrderShippingFees: 0,
            workOrderShippingTax: 0,
            workOrderItemTaxTotal: 0,
            workOrderShippingInstructions: null,
            workOrderSpecialComments: null,
            processFailed: false,
            formIsDirty: false,
            failedAuthAttempts: 0,
            requestedAmount: 0,
            approvedAmount: 0,
            filters: {
                saleId: 0,
                saleFulfillmentId: 0,
                exportOption: 0 // 0 - receipt; 1 - packing slip
            },
            skuFulfillmentLocationFailureType: Object.freeze({
                None: 0,
                Serialized: 1,
                Rental: 2,
                SpecialItemNonMerch: 3
            }),
            productFields: [
                {
                    key: 'skuProduct',
                    label: 'Product SKU'
                },
                {
                    key: 'description',
                    label: 'Description'
                },
                {
                    key: 'isbn',
                    label: 'ISBN',
                    tdClass: 'noWrap'
                },
                {
                    key: 'type',
                    label: 'Variants',
                    formatter: (value, key, item) => {
                        if (item.bookVariant == 1 || item.bookVariant == 2) {
                            return bookVariantFormatter(item.bookVariant);
                        } else {
                            return (
                                item.gmVariant1 +
                                (item.gmVariant1 ? '/' : '') +
                                item.gmVariant2
                            );
                        }
                    }
                },
                {
                    key: 'retailPrice',
                    label: 'Item Price',
                    formatter: currencyFormatter,
                    thClass: 'text-center',
                    tdClass: 'text-end'
                },
                {
                    key: 'productInventoryRetailPrice',
                    label: 'Inventory Price',
                    formatter: currencyFormatter,
                    thClass: 'text-center',
                    tdClass: 'text-end'
                },
                {
                    key: 'orderQty',
                    label: 'Web Order Qty',
                    thClass: 'text-center',
                    tdClass: 'text-end'
                },
                {
                    key: 'shippedQty',
                    label: 'Fulfilled Qty',
                    thClass: 'text-center',
                    tdClass: 'text-end'
                },
                {
                    key: 'cancelledQty',
                    label: 'Cancelled Qty ',
                    thClass: 'text-center',
                    tdClass: 'text-end'
                },
                {
                    key: 'extendedPrice',
                    label: 'Extended Price',
                    formatter: currencyFormatter,
                    thClass: 'text-center',
                    tdClass: 'text-end'
                },
                {
                    key: 'taxTotal',
                    label: 'Extended Tax (est)',
                    formatter: (value, key, item) => {
                        return currencyFormatter(item.taxTotal);
                    },
                    thClass: 'text-center',
                    tdClass: 'text-end'
                },
                {
                    key: 'backorderedQty',
                    label: 'Back Order Qty',
                    thClass: 'text-center',
                    tdClass: 'text-end'
                }
            ],
            SaleShipmentsFields: [
                {
                    key: 'skuProduct',
                    label: 'Product SKU'
                },
                {
                    key: 'description',
                    label: 'Description'
                },
                {
                    key: 'isbn',
                    label: 'ISBN',
                    tdClass: 'noWrap'
                },
                {
                    key: 'type',
                    label: 'Variants',
                    formatter: (value, key, item) => {
                        if (item.bookVariant == 1 || item.bookVariant == 2) {
                            return bookVariantFormatter(item.bookVariant);
                        } else {
                            return (
                                item.gmVariant1 +
                                (item.gmVariant1 ? '/' : '') +
                                item.gmVariant2
                            );
                        }
                    }
                },
                {
                    key: 'xref',
                    label: 'Serial / Xref',
                    class: 'tcw100'
                },
                {
                    key: 'itemPrice',
                    label: 'Item Price',
                    formatter: currencyFormatter,
                    thClass: 'text-center',
                    tdClass: 'text-end'
                },
                {
                    key: 'orderQty',
                    label: 'Web Order Qty',
                    thClass: 'text-center',
                    tdClass: 'text-end'
                },
                {
                    key: 'shippedQty',
                    label: 'Fulfilled Qty',
                    thClass: 'text-center',
                    tdClass: 'text-end'
                },
                {
                    key: 'extendedPrice',
                    label: 'Extended Price',
                    formatter: currencyFormatter,
                    thClass: 'text-center',
                    tdClass: 'text-end'
                },
                {
                    key: 'taxTotal',
                    label: 'Extended Tax',
                    formatter: currencyFormatter,
                    thClass: 'text-center',
                    tdClass: 'text-end'
                }
            ],
            refundFields: [
                { key: 'description', label: 'Description' },
                { key: 'skuProduct', label: 'SKU' },
                { key: 'remaining', label: 'Available', tdClass: 'text-center' },
                { key: 'qty', label: 'Refund Qty', tdClass: 'tcw100' },
                { key: 'amount', label: 'Amount', thClass: 'text-center', tdClass: 'tcw100' },
                { key: 'tax', label: 'Tax', thClass: 'text-center', tdClass: 'tcw100' }
            ],
            partialSaleFields: [
                {
                    key: 'skuProduct',
                    label: 'Product SKU'
                },
                {
                    key: 'description',
                    label: 'Description'
                },
                {
                    key: 'isbn',
                    label: 'ISBN',
                    tdClass: 'noWrap'
                },
                {
                    key: 'type',
                    label: 'Variants',
                    formatter: (value, key, item) => {
                        if (item.bookVariant == 1 || item.bookVariant == 2) {
                            return bookVariantFormatter(item.bookVariant);
                        } else {
                            return (
                                item.gmVariant1 +
                                (item.gmVariant1 ? '/' : '') +
                                item.gmVariant2
                            );
                        }
                    }
                },
                {
                    key: 'retailPrice',
                    label: 'Item Price',
                    formatter: currencyFormatter,
                    thClass: 'text-center',
                    tdClass: 'text-end'
                },
                {
                    key: 'orderQty',
                    label: 'Qty to Fill',
                    thClass: 'text-center',
                    tdClass: 'text-end'
                },
                {
                    key: 'shippedQty',
                    label: 'Fulfilled Qty',
                    thClass: 'text-center',
                    tdClass: 'text-end'
                },
                {
                    key: 'cancelledQty',
                    label: 'Cancelled Qty ',
                    thClass: 'text-center',
                    tdClass: 'text-end'
                },
                {
                    key: 'extendedPrice',
                    label: 'Extended Price',
                    formatter: currencyFormatter,
                    thClass: 'text-center',
                    tdClass: 'text-end'
                },
                {
                    key: 'taxTotal',
                    label: 'Extended Tax',
                    formatter: currencyFormatter,
                    thClass: 'text-center',
                    tdClass: 'text-end'
                },
                {
                    key: 'backorderedQty',
                    label: 'Back Order Qty',
                    thClass: 'text-center',
                    tdClass: 'text-end'
                }
            ],
            workOrderFields: [
                {
                    key: 'skuProduct',
                    label: 'Product SKU'
                },
                {
                    key: 'description',
                    label: 'Description'
                },
                {
                    key: 'isbn',
                    label: 'ISBN',
                    tdClass: 'noWrap'
                },
                {
                    key: 'type',
                    label: 'Variants',
                    formatter: (value, key, item) => {
                        if (item.bookVariant == 1 || item.bookVariant == 2) {
                            return bookVariantFormatter(item.bookVariant);
                        } else {
                            return (
                                item.gmVariant1 +
                                (item.gmVariant1 ? '/' : '') +
                                item.gmVariant2
                            );
                        }
                    }
                },
                {
                    key: 'retailPrice',
                    label: 'Item Price',
                    formatter: currencyFormatter,
                    thClass: 'text-center',
                    tdClass: 'text-end'
                },
                {
                    key: 'orderQty',
                    label: 'Qty to Fill',
                    thClass: 'text-center',
                    tdClass: 'text-end'
                },
                {
                    key: 'shippedQty',
                    label: 'Fulfilled Qty',
                    thClass: 'text-center',
                    tdClass: 'text-end'
                },
                {
                    key: 'cancelledQty',
                    label: 'Cancelled Qty',
                    thClass: 'text-center',
                    tdClass: 'text-end'
                },
                {
                    key: 'tax',
                    label: 'Ext. Tax (est)',
                    thClass: 'text-center',
                    tdClass: 'text-end'
                },
                {
                    key: 'extendedPrice',
                    label: 'Extended Price',
                    formatter: (value, key, item) => {
                        return currencyFormatter(
                            (item.isOnSale
                                ? item.itemPrice
                                : item.retailPrice) * item.shippedQty
                        );
                    },
                    thClass: 'text-center',
                    tdClass: 'text-end'
                },
                {
                    key: 'backorderedQty',
                    label: 'Back Order Qty',
                    thClass: 'text-center',
                    tdClass: 'text-end'
                },
            ],
            isTaxRefresh: false
        };
    },
    watch: {
        webOrder: NavigationGuard.$watcher,
        $route: function(to, from) {
            if (to !== from) {
                this.loadData();
            }
        },
        isTaxExempt: {
            handler: function(newVal) {
                if (newVal) {
                    this.clearTaxes();
                } else {
                    this.refreshTaxes();
                }
            }
        },
        validateFulfillmentLocation(value) {
            if (value.isReadOnly && value.message) {
                this.$appWarning(`Web order is in read-only mode. ${value.message}`);
            } else if (!value.isWorkable && value.message) {
                this.$appWarning(`Web order cannot be worked. ${value.message}`);
            }
        }
    },
    computed: {
        isReadOnly() {
            return this.validateFulfillmentLocation.isReadOnly;
        },
        isWorkable() {
            return this.validateFulfillmentLocation.isWorkable;
        },        
        validateFulfillmentLocation() {
            if (!this.webOrder) {
                return { isReadOnly: false, isWorkable: true, message: null };
            }
            
            if (this.currentFulfillmentLocationId !== this.currentlySelectedLocationId) {
                const selectedLocationName = useSelectListsStore().getLocationById(this.currentlySelectedLocationId)?.text;
                return {
                    isReadOnly: true,
                    isWorkable: false,
                    message: `Fulfillment location (${this.webOrder.fulfillmentLocation}) does not match the currently selected location (${selectedLocationName}).`
                };
            }
            
            var unfulfillableSerializedProducts = this.webOrder.products.filter(x => x.skuFulfillmentLocationFailureType === this.skuFulfillmentLocationFailureType.Serialized);
            if (unfulfillableSerializedProducts.length > 0) {
                const skuList = unfulfillableSerializedProducts.map(p => p.skuProduct).join(', ');
                return {
                    isReadOnly: false,
                    isWorkable: false,
                    message: `The following serialized product(s) have no available serial numbers at location ${this.webOrder.fulfillmentLocation}: ${skuList}. An available serial number is required to fulfill this order. Please update the product(s) or change the fulfillment location.`
                };
            }

            var unfulfillableRentalProducts = this.webOrder.products.filter(x => x.skuFulfillmentLocationFailureType === this.skuFulfillmentLocationFailureType.Rental);
            if (unfulfillableRentalProducts.length > 0) {
                const skuList = unfulfillableRentalProducts.map(p => p.skuProduct).join(', ');
                return {
                    isReadOnly: false,
                    isWorkable: false,
                    message: `The following rental product(s) may not be processed at location ${this.webOrder.fulfillmentLocation}: ${skuList}. Please change fulfillment location.`
                };
            }
            
            var unfulfillableSpecialItemNonMerchProducts = this.webOrder.products.filter(x => x.skuFulfillmentLocationFailureType === this.skuFulfillmentLocationFailureType.SpecialItemNonMerch);
            if (unfulfillableSpecialItemNonMerchProducts.length > 0) {
                const skuList = unfulfillableSpecialItemNonMerchProducts.map(p => p.skuProduct).join(', ');
                return {
                    isReadOnly: false,
                    isWorkable: false,
                    message: `The following special item non-merch product(s) may not be processed at location ${this.webOrder.fulfillmentLocation}: ${skuList}. Please update product(s) or change fulfillment location.`
                };
            }  
            
            return { isReadOnly: false, isWorkable: true, message: null };
        },
        calcShippedQty() {
            return this.workOrder.partialSales.reduce(
                (a, b) => a + b.shippedQty,
                0
            );
        },
        calcWorkOrderSubTotal() {
            return roundingFormatter(
                this.workOrder.partialSales.reduce(
                    (a, b) =>
                        a +
                        (b.isOnSale ? b.itemPrice : b.retailPrice) *
                            b.shippedQty,
                    0
                ),
                2
            );
        },
        calcWorkOrderItemTaxTotal() {
            if (this.webOrder.isTaxExempt) {
                return roundingFormatter(0, 2);
            }
            return roundingFormatter(
                this.workOrder.partialSales.reduce((a, b) => {
                    if (b.taxOverride != null) {
                        let perItemTax = this.getItemTax(b) / b.webOrderQty;
                        return a + perItemTax * b.shippedQty;
                    } else {
                        return a + (b.taxTotal / b.webOrderQty) * b.shippedQty;
                    }
                }, 0),
                2
            );
        },
        calcWorkOrderTotal() {
            return this.calcShippedQty > 0
                ? this.calcWorkOrderSubTotal +
                      this.workOrderShippingFees +
                      this.workOrder.manualOverrideUserInput +
                      this.calcWorkOrderItemTaxTotal
                : 0;
        },
        disabledProcess() {
            return (this.workOrder.partialSales.length == 0 
                || this.calcWorkOrderTotal < 0 
                || (this.calcWorkOrderTotal > 0 && this.failedAuthAttempts >= 5)
                || (this.workOrder.paymentMethod?.isARAccount && !this.workOrder.paymentMethod.noLimit 
                        && this.workOrder.paymentMethod.availableFunds < this.calcWorkOrderTotal
                        && this.webOrder.paymentMethods.length == 1));
            },
        getLastUpdateDate() {
            let lastUpdate = null;
            if (this.webOrder.lastUpdateDate) {
                lastUpdate = dateFormatter(this.webOrder.lastUpdateDate);
            }
            return lastUpdate;
        },
        canAddProducts() {
            return (
                this.webOrder?.webOrderStatus.toLowerCase() == 'open' ||
                this.webOrder?.webOrderStatus.toLowerCase() == 'partial' ||
                this.webOrder?.webOrderStatus.toLowerCase() == 'failed' ||
                this.webOrder?.webOrderStatus.toLowerCase() == 'backordered'
            );
        },
        canAddShippingFee() {
            return (
                this.calcShippedQty > 0 &&
                (this.webOrder?.webOrderStatus.toLowerCase() == 'open' ||
                    this.webOrder?.saleShipments.length == 0)
            );
        },
        isTaxExempt() {
            return this.webOrder?.isTaxExempt ?? false;
        },
        fulfillmentLocationFilter() {
            const appStateStore = useAppStateStore();
            const fulfillmentLocationIds = appStateStore.getWebOrderFulfillmentLocationIds;
            const mainLocationId = appStateStore.getSingleLocationId;
            return (location) => fulfillmentLocationIds.includes(location.value) || location.value === mainLocationId;
        },
        shippingCodeFilter() {
            return (shippingCode) => !shippingCode.disabled;
        },
        // Negated at display time: prices are stored positive; a refund shows as a negative amount.
        refundTotal() {
            let total = this.refundLines.reduce(
                (sum, l) => sum + RefundCalculations.lineRefundTotal(l.baseAmount, l.baseTax, l.qty, l.sourceQty),
                0
            );
            if (this.refundShipment && this.refundShipment.canRefundShipping) {
                total += (this.refundShippingAmount || 0) + (this.refundShippingTax || 0);
            }
            return -total;
        },
    },
    methods: {
        addressFormatter: addressFormatter,
        calcExtTaxPartialSale(item) {
            let perItemTax = this.getItemTax(item) / item.webOrderQty;
            return roundingFormatter(perItemTax * item.orderQty, 2);
        },
        calculateExtendedTax(item) {
            let perItemTax = this.getItemTax(item) / item.webOrderQty;
            return roundingFormatter(perItemTax * item.shippedQty, 2);
        },
        webOrderPaymentMethod(item, paymethod) {
            const paymentMethod = this.webOrder.paymentMethods.find(pm => pm.saleTenderId === paymethod.saleTenderId);
            
            if (paymentMethod) {
                // Apply values to the found payment method
                paymentMethod.accountNumber = item.accountNumber;
                paymentMethod.agencyName = item.accountName;
                paymentMethod.selectedAccountBalanceId = item.accountBalanceId;
                paymentMethod.isCCAccount = false;
                paymentMethod.isARAccount = true;
                paymentMethod.paymentMethodName = item.paymentMethod;
                paymentMethod.saleTenderId = paymethod.saleTenderId;
            }
            paymentMethod.isTaxExempt = item.isTaxExempt;
            this.onSubmit();
        },
        getShippingTax(order) {
            return this.webOrder.isTaxExempt
                ? 0
                : order.shippingTaxOverride?.amount ?? order.shippingTax;
        },
        getItemTax(item) {
            return this.webOrder.isTaxExempt
                ? 0
                : item.taxOverride?.amount ?? item.taxTotal;
        },
        fulfilledQtyChanged(event, item) {
            if(this.workOrder.paymentMethod.dccIds.length > 0 && !this.workOrder.paymentMethod.dccIds.includes(item.dccId) && item.shippedQty !== 0) {
                item.shippedQty = 0;
                this.$appError(`Payment type does not allow the purchase of SKU ${item.skuProduct}: ${item.description}.`);
                return;
            }

            this.workOrderItemTaxTotal = this.calcWorkOrderItemTaxTotal;
            let perItemTax = this.getItemTax(item) / item.webOrderQty;
            item.manualOverrideUserInput = roundingFormatter(perItemTax * item.shippedQty, 2);
            
            item.shippedQty = this.zeroIfNullFormatter(item.shippedQty);

            this.resizeSerialNumberArray(item, item.shippedQty);
            this.resizeRentalXrefArray(item, item.shippedQty);
        },
        zeroIfNullFormatter(value) {
            // v-model.number leaves a cleared input as '' (not null), so cover empty and NaN too.
            if (value == null || value === '' || (typeof value === 'number' && isNaN(value))) return 0;
            return value;
        },
        getShippedQtyRules(item) {
            return `min_value:0|exceed-shipped-qty:${item.orderQty},${item.cancelledQty}`;
        },
        getCancelledQtyRules(item) {
            return `min_value:0|exceed-cancelled-qty:${item.orderQty},${item.shippedQty}`;
        },
        getBackOrderQtyRules(item) {
            return `min_value:0|exceed-back-order-qty:${item.orderQty},${item.cancelledQty},${item.shippedQty}`;
        },
        noQtyToFill() {
            return (
                this.workOrder.partialSales.reduce(
                    (acc, item) => acc + item.orderQty,
                    0
                ) == 0
            );
        },
        phoneFormatter: phoneFormatter,
        dateFormatter: dateFormatter,
        datetimeToLocalTimeFormatter: datetimeToLocalTimeFormatter,
        currencyFormatter: currencyFormatter,
        onSubmit: async function(isDepartmentCharge = false) {
            this.isBusy = true;            

            this.webOrder.ShippingFee =
                this.workOrderShippingFees > 0
                    ? this.workOrderShippingFees
                    : this.webOrder.shippingTotal;

            this.webOrder.isDepartmentCharge = isDepartmentCharge;
            this.formIsDirty = false;
            axios
                .post('weborders', this.webOrder)
                .then(() => {
                        this.dataSaved();
                        this.$appSuccess(
                                `Web Order '${this.webOrder.name}' saved successfully.`
                            )
                })
                .finally(() => {
                    this.isBusy = false;
                    this.loadData();
                });
        },        
        async processWorkOrder() {
            // A serial/rental row's validity (item.isValid) and its serialCustomerId
            // are only resolved by the async field validation (updateSerialValidation
            // / validateRentalXref), which normally fires on blur. If Process is
            // clicked while a serial input is still focused, that async never ran:
            // the field still looks valid (an undefined isValid is treated as valid
            // by the is-valid-serial-number rule) and serialCustomerId is still null
            // — which fails int deserialization server-side. Force every serial/xref
            // to validate (populating serialCustomerId for valid ones) and await them
            // before validating the form, then let validate() block on any failures.
            const serialsValid = await this.validateAllSerialsAndXrefs();
            await this.$nextTick();

            // Validate the work order modal's form (formModal) — the serialized
            // product Serial Number inputs and qty fields live there. Validating the
            // outer page form (ref="form") skips them. Serial/xref validity is gated
            // separately (serialsValid) because those flags reach vee-validate via an
            // inline :rules object that hasn't re-evaluated yet on this same tick, so
            // a just-detected used/duplicate serial would slip past validate() alone.
            const formValid = await this.$refs.formModal.validate();
            if (!serialsValid || !formValid) {
                return;
            }

            const totalShippedQty = this.workOrder.partialSales.reduce((sum, partialSale) => sum + partialSale.shippedQty, 0);
            const totalCancelledQty = this.workOrder.partialSales.reduce((sum, partialSale) => sum + partialSale.cancelledQty, 0);
            const totalBackorderedQty = this.workOrder.partialSales.reduce((sum, partialSale) => sum + partialSale.backorderedQty, 0);
            if(totalShippedQty + totalCancelledQty + totalBackorderedQty <= 0) {
                this.$appError(`No product quantities entered (Fulfilled Qty, Cancelled Qty, or Back Order Qty).  Web order cannot be processed.`);
                return;
            }

            this.isBusy = true;
            (this.workOrder.saleId = this.webOrder.saleId),
                (this.workOrder.name = this.webOrder.name),
                (this.workOrder.shippingTax =
                    this.calcShippedQty > 0
                        ? this.getShippingTax(this.workOrder)
                        : 0),
                (this.workOrder.shippingTotal =
                    this.calcShippedQty > 0 ? this.workOrderShippingFees : 0);
            this.workOrder.total = this.calcWorkOrderTotal;
            this.workOrder.itemTaxTotal = this.calcWorkOrderItemTaxTotal;
            this.workOrder.subTotal = this.calcWorkOrderSubTotal;
            this.workOrder.shippingInstructions = this.workOrderShippingInstructions;
            this.workOrder.specialComments = this.workOrderSpecialComments;
            this.workOrder.saleFulfillmentId = 0;
            this.workOrder.isTaxExempt = this.webOrder.isTaxExempt;

            axios
                .post('weborders/processweborder', this.workOrder)
                .then(resp => {
                    if (resp) {
                        if (
                            !resp.data.taxApiResult &&
                            !this.webOrder.isTaxExempt
                        ) {
                            this.$bvModal
                                .msgBoxConfirm(
                                    "Automated tax update is not available. Please select 'Back to Work Order' to verify values, or 'Continue Processing' to accept tax values currently shown on web order and proceed.",
                                    {
                                        okVariant: 'danger',
                                        okTitle: 'Continue Processing',
                                        cancelTitle: 'Back to Work Order'
                                    }
                                )
                                .then(value => {
                                    if (value) {
                                        this.isBusy = true;
                                        this.workOrder.isContinueProcessing = true;
                                        this.workOrder.saleFulfillmentId = resp.data.saleFulfillmentId;

                                        axios
                                            .post(
                                                'weborders/processweborder',
                                                this.workOrder
                                            )
                                            .then(resp => {
                                                if (resp) {
                                                    this.responseMessage(resp);
                                                }
                                            })
                                            .finally(() => {
                                                this.isBusy = false;
                                            });
                                    }
                                });
                        } else {
                            this.responseMessage(resp);
                        }
                    }
                })
                .finally(() => {
                    this.isBusy = false;
                });
        },
        responseMessage(resp) {
            this.workOrder.isContinueProcessing = false;
            if (resp.data.posAPIResult) {
                this.loadData();
                this.$refs.workOrderModal.hide();
                this.$appSuccess(
                        `Web Order '${this.webOrder.name}' processed successfully.`
                    )
            } else {
                this.workOrder.saleFulfillmentId = resp.data.saleFulfillmentId;
                this.failedAuthAttempts = resp.data.failedAuthAttempts;
                this.processFailed = !resp.data.posAPIResult;
                this.requestedAmount = resp.data.requestedAmount;
                this.approvedAmount = resp.data.approvedAmount;
                this.webOrder.webOrderStatus = 'Failed';
                if(resp.data.failedMessage)
                {
                    this.$appError(resp.data.failedMessage)
                }
                this.dataLoaded();
            }
        },
        processCancelShipment() {
            this.isBusy = true;
            this.$refs.workOrderModal.hide();
            axios
                .post('weborders/cancelshipment', this.webOrder)
                .then(() => {
                    this.$appSuccess(
                            `Shipment processing was successfully cancelled.`
                        )
                })
                .finally(() => {
                    this.loadData();
                    this.isBusy = false;
                });
        },
        async handleCancelOrder(type) {
            this.isBusy = true;
            let hasBackOrderItems =
                this.webOrder.webOrderStatus.toLowerCase() == 'backordered' ||
                this.webOrder.webOrderStatus.toLowerCase() ==
                    'partial/backordered';

            if (hasBackOrderItems) {
                await this.$bvModal
                    .msgBoxConfirm(
                        `This Order has Backordered Items. Do you wish to continue cancelling?`
                    )
                    .then(value => {
                        if (value) {
                            this.cancelOrder(type);
                        } else {
                            this.isBusy = false;
                        }
                    });
            } else {
                await this.cancelOrder(type);
            }
        },
        handleReopen() {
            if (
                this.webOrder.webOrderStatus.toLowerCase() ==
                    'completed at register' ||
                this.webOrder.webOrderStatus.toLowerCase() == 'cancelled'
            ) {
                this.$bvModal
                    .msgBoxConfirm(
                        this.webOrder.webOrderStatus.toLowerCase() ==
                            'completed at register'
                            ? `This order may have already been completed at the register.  Are you sure you want to reopen it?`
                            : this.webOrder.webOrderStatus.toLowerCase() ==
                              'cancelled'
                            ? `This order was previously cancelled. Are you sure you want to reopen it?`
                            : '',
                        {
                            okTitle: 'Yes',
                            cancelTitle: 'No'
                        }
                    )
                    .then(value => {
                        if (value) {
                            this.workOrder.IsReopen = true;
                            this.workOrder.saleId = this.webOrder.saleId;
                            this.workOrder.name = this.webOrder.name;
                            this.workOrder.total = 0;
                            this.isBusy = true;

                            this.workOrder.saleFulfillmentId = 0;
                                         axios
                                            .post(
                                                'weborders/processweborder',
                                                this.workOrder
                                            )
                                            .then(resp => { 
                                                     if (resp.data.posAPIResult) {
                                                        
                                                        this.workOrder.IsReopen = false;
                                                        this.loadData();
                                                         this.$refs.workOrderModal.hide();
                                                         this.$appSuccess(
                                    `Web Order '${this.webOrder.name}' has been reopened successfully.`
                                );
                                                     }  
                                            })
                                            .finally(() => {
                                                this.workOrder.IsReopen = false;
                                                this.isBusy = false;
                                            });
                        }
                    })

                    
            }
        },
        async cancelOrder(type) {
            if (type === 'completeAtRegister') {
                this.workOrder.IsCompletedAtRegister = true;
            }
            this.workOrder.partialSales.forEach(x => {
                x.cancelledQty = x.orderQty;
                x.shippedQty = 0;
            });
            this.workOrder.saleId = this.webOrder.saleId;
            this.workOrder.name = this.webOrder.name;
            this.workOrder.total = 0;
            axios
                .post('weborders/processweborder', this.workOrder)
                .then(resp => {
                    if (resp) {
                        if (resp.data.posAPIResult) {
                            this.loadData();
                            if (type === 'completeAtRegister') {
                                this.$appSuccess(
                                        `Web Order '${this.webOrder.name}' has been marked as Completed at Register.`
                                    )
                            } else {
                                this.$appSuccess(
                                        `Web Order '${this.webOrder.name}' cancelled successfully.`
                                    )
                            }
                        }
                    }
                })
                .finally(() => {
                    this.isBusy = false;
                });
        },
        handleAddCustomer() {
            if (!this.$refs.formModal.validate()) {
                return;
            }                     
            let promise = axios.get('customers', {
                params: { id: this.webOrder.customer.customerId }
            });
            promise.then(resp => {
                this.webOrder.customer.firstName = resp.data.firstName;
                this.webOrder.customer.lastName = resp.data.lastName;
                this.webOrder.customer.email = resp.data.email;
                this.webOrder.customer.phone.number =
                    resp.data.defaultPhone.number;
                this.webOrder.customer.number = resp.data.number;
                this.$refs.editCustomerModal.hide();
                this.onSubmit();
            });
        },
        showModal() {
            this.customerId = this.webOrder.customer.customerId;
        },
        showWorkOrderModal() {
            // Reset the per-open guard so the next close reloads exactly once.
            this._workOrderHideHandled = false;
            this.workOrder.partialSales.forEach(partialSale => {
                partialSale.manualOverrideUserInput = roundingFormatter(this.calculateExtendedTax(partialSale), 2);

                // Set the initial shipped quantity based on whether the payment method's Dccs match the partial sale's product's Dcc
                partialSale.shippedQty = this.fulfillmentAllowedForPaymentMethod(partialSale, this.workOrder) ? partialSale.orderQty : 0;
                partialSale.cancelledQty = 0;
                partialSale.backorderedQty = 0;
                this.resizeSerialNumberArray(partialSale, partialSale.shippedQty);
                this.resizeRentalXrefArray(partialSale, partialSale.shippedQty);
            });

            //only add shipping on first shipment.
            this.workOrderShippingFees = this.canAddShippingFee
                ? this.webOrder.shippingTotal
                : 0;
            this.workOrderShippingTax = this.canAddShippingFee
                ? this.getShippingTax(this.workOrder)
                : 0;
            this.workOrder.manualOverrideUserInput = this.canAddShippingFee ? this.getShippingTax(this.workOrder) : 0;

            this.workOrderItemTaxTotal = this.calcWorkOrderItemTaxTotal;
            this.workOrderShippingInstructions = this.webOrder.shippingInstructions;
            this.workOrderSpecialComments = this.webOrder.specialComments;
        },
        fulfillmentAllowedForPaymentMethod(partialSale, workOrder) {
            if(workOrder.paymentMethod.dccIds.length === 0) 
                return true; // Payment method has no Dccs assigned, so all products are valid for purchase
            
            if(workOrder.paymentMethod.dccIds.includes(partialSale.dccId))
                return true; // A payment method Dcc matches the partial sale Dcc, and is valid for purchase
            
            return false; // No payment method Dcc matches the partial sale Dcc, so the partial sale product is not valid for purchase
        },        
        hideWorkOrderModal() {
            // bootstrap-vue-next fires `hide` more than once for a single close
            // (see NavigationGuard), which would reload the web order — and re-hit
            // the weborders GET — multiple times. Only handle the first hide per open.
            if (this._workOrderHideHandled) return;
            this._workOrderHideHandled = true;
            this.loadData();
        },
        handleItemTaxOverride(event, item) {
            // bootstrap-vue-next emits the native DOM Event from @change; extract the value.
            const rawValue = event instanceof Event ? event.target?.value : event;
            const parsed = rawValue == null || rawValue === '' ? 0 : Number(rawValue);
            // This handler reads the raw DOM value (not the sanitized p-number model),
            // so guard against a partial entry like "." producing NaN.
            const newAmount = Number.isFinite(parsed) ? parsed : 0;

            //save original value incase they decide to cancel the tax override.
            var oldTaxAmount = roundingFormatter(
                item.manualOverrideUserInput,
                2
            );

            //if the values are different, update. If not return leaving the value as is.
            if (newAmount != oldTaxAmount) {
                item.manualOverrideUserInput = newAmount;
            } else {
                return;
            }

            if (oldTaxAmount == null) {
                item.manualOverrideUserInput = this.getItemTax(item);
                return;
            }

            let confirmMessage = item.taxOverrideId
                ? 'Are you sure you want to update the Tax Override for this item?'
                : 'Are you sure you want to create a Tax Override for this item?';

            this.$bvModal.msgBoxConfirm(confirmMessage).then(value => {
                if (value) {
                    this.isBusy = true;
                    let taxOverrideDto = {
                        amount: this.zeroIfNullFormatter(
                            item.manualOverrideUserInput
                        ),
                        saleItemId: item.saleItemId
                    };
                    axios
                        .post('taxes/saleitemtaxoverride', taxOverrideDto)
                        .then(resp => {
                            if (item.taxOverride) {
                                item.taxOverride.amount = taxOverrideDto.amount;
                            } else {
                                item.taxOverride = resp.data;
                            }
                            let perItemTax =
                                item.taxOverride.amount / item.webOrderQty;
                            item.manualOverrideUserInput = roundingFormatter(
                                perItemTax * item.shippedQty,
                                2
                            );

                            let webOrderItem = this.webOrder.products.find(
                                x => x.skuProduct == item.skuProduct
                            );
                            if (webOrderItem) {
                                webOrderItem.taxTotal = item.taxOverride.amount;
                            }
                            this.dataLoaded();
                            this.$appSuccess(`Tax Override saved successfully.`)
                        })
                        .finally(() => {
                            this.isBusy = false;
                        });
                } else {
                    item.manualOverrideUserInput = oldTaxAmount;
                }
            });
        },
        handleShippingTaxOverride(event, workOrder) {
            if (workOrder.manualOverrideUserInput == null) {
                workOrder.manualOverrideUserInput = this.workOrderShippingTax;
                return;
            }

            if (
                workOrder.manualOverrideUserInput == this.workOrderShippingTax
            ) {
                return;
            }

            let oldTaxOverride = JSON.parse(
                JSON.stringify(workOrder.shippingTaxOverride)
            );
            workOrder.shippingTaxOverride = {
                saleItemTaxOverrideId: workOrder.shippingTaxOverrideId,
                amount: this.zeroIfNullFormatter(
                    workOrder.manualOverrideUserInput
                )
            };
            let confirmMessage = workOrder.shippingTaxOverrideId
                ? 'Are you sure you want to update the Tax Override for shipping tax?'
                : 'Are you sure you want to create a Tax Override for shipping tax?';

            this.$bvModal.msgBoxConfirm(confirmMessage).then(value => {
                if (value) {
                    this.isBusy = true;
                    let taxOverrideDto = {
                        amount: this.zeroIfNullFormatter(
                            workOrder.manualOverrideUserInput
                        ),
                        saleItemId: this.webOrder.shippingTaxItemId
                    };
                    axios
                        .post('taxes/saleitemtaxoverride', taxOverrideDto)
                        .then(resp => {
                            this.webOrder.shippingTax = this.workOrderShippingTax =
                                resp.data.amount;
                            this.dataLoaded();
                            this.$appSuccess(`Tax Override saved successfully.`)
                        })
                        .finally(() => {
                            this.isBusy = false;
                        });
                } else {
                    workOrder.taxOverride = JSON.parse(
                        JSON.stringify(oldTaxOverride)
                    );
                    workOrder.manualOverrideUserInput = this.workOrderShippingTax;
                }
            });
        },
        processShipment() {
            axios.post('weborders/processshipment', this.webOrder).then(() => {
                this.$appSuccess(
                        `Shipment '${this.webOrder.name}' processed successfully.`
                    )
            });
        },
        refreshAllTaxes() {
            this.$bvModal
                .msgBoxConfirm(
                    'This will refresh all tax values on the current screen, including overridden values.'
                )
                .then(value => {
                    if (value) {
                        this.refreshTaxes();
                    }
                });
        },
        async refreshTaxes() {
            this.webOrder.isTaxRefresh = true;
            this.isTaxRefresh = true;

            this.isRefreshBusy = true;

            this.webOrder.ShippingFee =
                this.workOrderShippingFees > 0
                    ? this.workOrderShippingFees
                    : this.webOrder.shippingTotal;

            this.webOrder.isDepartmentCharge = false;            
            this.formIsDirty = false;
            axios
                .post('weborders/refreshtaxweborder', this.webOrder)                
                .finally(() => {                
                    this.isRefreshBusy = false;
                    this.loadData();
                });
        },
        clearTaxes() {
            if (this.webOrder.webOrderStatus.toLowerCase() == 'open') {
                this.webOrder.products.forEach(x => (x.taxTotal = 0));
                this.webOrder.partialSales.forEach(x => (x.taxTotal = 0));
                this.workOrder.partialSales.forEach(x => (x.taxTotal = 0));

                this.webOrder.shippingTax = 0;
                this.webOrder.extendedTaxTotal = 0;
                this.webOrder.taxTotal = 0;
                this.webOrder.total =
                    this.webOrder.subtotal + this.webOrder.shippingTotal;
            }
        },
        saveDCPromptDetails(updatedPaymentMethod) {
            const index = this.webOrder.paymentMethods.findIndex(pm => pm.saleTenderId === updatedPaymentMethod.saleTenderId);

            if (index === -1) 
            {
                return;
            }

            this.webOrder.paymentMethods.splice(index, 1, updatedPaymentMethod);
            
            this.onSubmit(true);
        },
        async loadData() {
            this.isBusy = true;
            this.isRefreshBusy = true;

            axios
                .get('weborders', {
                    params: {
                        locationId: await selectListOptionsDataContext.getSelectedLocationIdAsync(),
                        id: this.id
                    }
                })
                .then(resp => {
                    this.webOrder = resp.data;
                    this.webOrder.products.forEach(x =>
                        x._showDetails = true
                    );
                    this.webOrder.partialSales.forEach(x =>
                        x._showDetails = true
                    );
                    this.webOrder.saleShipments.forEach(x =>
                        x._showDetails = true
                    );
                    if (this.webOrder.webOrderStatus.toLowerCase() != 'open') {
                        this.workOrder.partialSales = [
                            ...this.webOrder.partialSales.map(x => ({ ...x }))
                        ];
                    } else {
                        this.workOrder.partialSales = [
                            ...this.webOrder.products.map(x => ({ ...x }))
                        ];
                    }
                    this.workOrder.partialSales.forEach(x => {
                        (x.shippedQty = x.orderQty),
                            (x.cancelledQty = 0),
                            (x.backorderedQty = 0);
                    });

                    this.currentFulfillmentLocationId = this.webOrder.fulfillmentLocationId;

                    this.workOrder.shippingTax = this.webOrder.shippingTax;
                    this.workOrder.shippingTaxOverride = this.webOrder.shippingTaxOverride;
                    this.workOrder.shippingTaxOverrideId = this.webOrder.shippingTaxOverrideId;

                    this.failedAuthAttempts = this.webOrder.failedAuthAttempts;
                    if (this.webOrder.failedAuthAttempts == 5) {
                        this.processFailed = true;
                    }
                    if (this.isTaxRefresh) {
                        this.refreshIsBusy = true;
                        this.showWorkOrderModal();
                        this.isTaxRefresh = false;
                    }

                    // This is a kludge to allow the rest of the UI code to be left as-is for now by only putting a single payment method on the work order.  
                    // Later we probably revisit this to work with all the web order payment methods.
                    this.workOrder.paymentMethod = this.getWorkOrderPaymentMethod(this.webOrder.paymentMethods);

                    this.dataLoaded();
                })
                .finally(() => {
                    this.isBusy = false;
                    this.isRefreshBusy = false;
                });
        },
        getWorkOrderPaymentMethod(paymentMethods) {
            const methods = paymentMethods || [];
            const filtered = methods.filter(pm => !pm.isGuarantee);
            if (filtered.length > 0)
                return filtered[0];
            if (methods.length === 1)
                return methods[0];
            return null;
        },
        exportShipment(saleShipment, option) {
            if (option == 0) {
                this.isReceiptBusy = true;
            } else {
                this.isPackingBusy = true;
            }

            this.filters.saleId = saleShipment.saleId;
            this.filters.saleFulfillmentId = saleShipment.saleFulfillmentId;
            this.filters.exportOption = option;

            axios
                .post('/weborders/exportshipment', this.filters, {
                    responseType: 'blob'
                })
                .then(result => {
                    if (option == 0) {
                        downloadFileToBrowser(
                            result.data,
                            'Web Shipment Receipt ' +
                                saleShipment.saleFulfillmentName,
                            'application/pdf'
                        );
                        this.$appSuccess(
                                'Web Shipment Receipt ' +
                                    saleShipment.saleFulfillmentName,
                                ' generated successfully.'
                            )
                    } else {
                        downloadFileToBrowser(
                            result.data,
                            'Web Packing Slip ' +
                                saleShipment.saleFulfillmentName,
                            'application/pdf'
                        );
                        this.$appSuccess(
                                'Web Packing Slip ' +
                                    saleShipment.saleFulfillmentName,
                                ' generated successfully.'
                            )
                    }
                })
                .finally(() => {
                    if (option == 0) {
                        this.isReceiptBusy = false;
                    } else {
                        this.isPackingBusy = false;
                    }
                });
        },
        addSelectedItems: function(items) {
            this.isBusy = true;
            // now I have questions about how we deal with locations...
            // I'd also really like to extract this logic to a class...
            let details = items.map(item => ({
                backorderedQty: 0,
                bookVariant: item.bookVariant,
                cancelledQty: 0,
                comments: '',
                saleItemId: null,
                shippedQty: 0,
                defaultBarcode: item.barcodes,
                description: item.authorTitleOrDescription,
                retailPrice: item.retail,
                itemPrice: item.retail,
                extendedPrice:
                item.retail *
                    (item.orderQty == null || item.orderQty == 0
                        ? 1
                        : item.orderQty + 1),
                gmVariant1: item.gmVariant1 ?? '',
                gmVariant2: item.gmVariant2 ?? '',
                isbn: item.isbn,
                skuProduct: item.sku,
                specialItemId: null,
                taxTotal: item?.Value ?? 0,
                saleId: this.webOrder.saleId,
                isSerialized: false,
                dccId: item.dccId
            }));

            // Validate that the added products are fulfillable by matching the payment method's DCCs with the product's DCC
            for(const detail of details) {
                if(this.workOrder.paymentMethod.dccIds.length > 0 && !this.workOrder.paymentMethod.dccIds.includes(detail.dccId)) {
                    this.$appError(`Payment type does not allow the purchase of at least one selected product, SKU ${detail.skuProduct}: ${detail.description}.`)
                    this.isBusy = false;
                    return;
                }
            }

            details.forEach(x => {
                var product = this.webOrder.products.find(
                    a => a.skuProduct == x.skuProduct
                );
                if (product != null) {
                    product.orderQty += 1;
                    product.extendedPrice =
                        product.orderQty *
                        (product.isOnSale
                            ? product.itemPrice
                            : product.retailPrice);
                } else {
                    x.orderQty = 1;
                }
            });

            this.webOrder.products = unionBy(
                this.webOrder.products,
                details,
                x => x.skuProduct
            );
            this.onSubmit();
        },
        validateWorkOrder: function() {
            if (this.formIsDirty) {
                this.$appError(
                    'Please save or discard changes by reloading the page before working order'
                );
            } else {
                this.$refs.workOrderModal.show();
            }
        },
        async updateSerialValidation(product, value, item) {
            this.isValidatingField = true;
            if (value) {
                if (product.serialNumbers) {
                    item.isUnique = product.serialNumbers.filter(
                            x => x.serialNumber === value
                        ).length <= 1;
                }

                let isValid = false;
                let resp = await axios.get('/weborders/validateserialnumber', {
                    params: {
                        locationId: await selectListOptionsDataContext.getSelectedLocationIdAsync(),
                        sku: product.skuProduct,
                        serialNumber: value
                    }
                });

                if (resp && resp.data && resp.data.isValid) {
                    isValid = true;
                    item.serialMessage = null;
                    resp.data.serialCustomer.serialNumber = value;
                    let index = product.serialNumbers.findIndex(
                        x => x.serialNumber == value
                    );
                    Object.assign(
                        product.serialNumbers[index],
                        resp.data.serialCustomer
                    );
                } else {
                    // A serial that exists but came back invalid is already sold/in use;
                    // a null serialCustomer means it isn't a recognized serial at all.
                    item.serialMessage = resp?.data?.serialCustomer
                        ? 'This serial number is already in use.'
                        : 'Invalid serial number.';
                }
                item.isValid = isValid;
            }
            this.isValidatingField = false;
        },
        // Run the async serial/xref validation for every row up front (used by
        // Process). Without this, clicking Process while a field is still focused
        // skips the blur-bound validation, leaving isValid undefined (treated as
        // valid) and serialCustomerId null — which then fails server-side.
        async validateAllSerialsAndXrefs() {
            const tasks = [];
            for (const partialSale of this.workOrder.partialSales) {
                if (partialSale.isSerialized && partialSale.serialNumbers) {
                    for (const sn of partialSale.serialNumbers) {
                        tasks.push(this.updateSerialValidation(partialSale, sn.serialNumber, sn));
                    }
                }
                if (partialSale.isRental && partialSale.rentalXrefs) {
                    for (const xref of partialSale.rentalXrefs) {
                        tasks.push(this.validateRentalXref(partialSale, xref.rentalXref, xref));
                    }
                }
            }
            await Promise.all(tasks);

            // Return validity from the flags we just set, rather than leaving it to
            // the form's validate() — the inline :rules carrying isValid/isUnique
            // don't refresh in time for a single-click Process to catch a used or
            // duplicate serial. (isValid === false: used/unavailable or not found;
            // isUnique === false: duplicated within this order.)
            const serialBad = sn => sn.isValid === false || sn.isUnique === false;
            const xrefBad = x => x.isValid === false || x.isUnique === false;
            return this.workOrder.partialSales.every(ps =>
                (!ps.isSerialized || !ps.serialNumbers || !ps.serialNumbers.some(serialBad))
                && (!ps.isRental || !ps.rentalXrefs || !ps.rentalXrefs.some(xrefBad)));
        },
        async validateRentalXref(product, rentalXref, item) {
            this.isValidatingField = true;
            if (rentalXref) {
                if (product.rentalXrefs) {
                    item.isUnique = product.rentalXrefs.filter(
                            x => x.rentalXref === rentalXref
                        ).length <= 1;
                }

                let resp = await axios.get('/weborders/validaterentalxref', {
                    params: {
                        rentalXref: rentalXref
                    }
                });

                let isValid = resp && resp.data && resp.data.isValid;
                item.isValid = isValid;
            }
            this.isValidatingField = false;
        },
        resizeSerialNumberArray(productItem, size) {
            if (productItem.isSerialized) {
                if (size <= 0) {
                    if (productItem.serialNumbers) {
                        productItem.serialNumbers.splice(
                            0,
                            productItem.serialNumbers.length
                        );
                    }
                    return;
                }

                if (!productItem.serialNumbers) {
                    productItem.serialNumbers = [];
                }

                let delta = productItem.serialNumbers.length - size;

                //remove empty rows first
                if (delta > 0) {
                    for (
                        let i = productItem.serialNumbers.length - 1;
                        i >= 0 && delta > 0;
                        i--
                    ) {
                        if (!productItem.serialNumbers[i].serialNumber) {
                            productItem.serialNumbers.splice(i, 1);
                            delta--;
                        }
                    }
                    while (delta-- > 0) {
                        productItem.serialNumbers.pop();
                    }
                    return;
                }

                while (delta++ < 0) {
                    productItem.serialNumbers.push({
                        serialCustomerId: null,
                        serialLocationId: null,
                        customerId: null,
                        mfgXref: null,
                        xref: null,
                        isAvailable: null,
                        serialNumber: null
                    });
                }
            }
        },
        resizeRentalXrefArray(productItem, size) {
            if (productItem.isRental) {
                if (size <= 0) {
                    if (productItem.rentalXrefs) {
                        productItem.rentalXrefs.splice(
                            0,
                            productItem.rentalXrefs.length
                        );
                    }
                    return;
                }

                if (!productItem.rentalXrefs) {
                    productItem.rentalXrefs = [];
                }

                let delta = productItem.rentalXrefs.length - size;

                //remove empty rows first
                if (delta > 0) {
                    for (
                        let i = productItem.rentalXrefs.length - 1;
                        i >= 0 && delta > 0;
                        i--
                    ) {
                        if (!productItem.rentalXrefs[i].rentalXref) {
                            productItem.rentalXrefs.splice(i, 1);
                            delta--;
                        }
                    }
                    while (delta-- > 0) {
                        productItem.rentalXrefs.pop();
                    }
                    return;
                }

                while (delta++ < 0) {
                    productItem.rentalXrefs.push({
                        rentalXref: null
                    });
                }
            }
        },
        remainingRefundable(product) {
            return (product.shippedQty || 0) - (product.refundedQty || 0);
        },
        refundAppliedAmount(item) {
            return RefundCalculations.applied(item.baseAmount, item.qty, item.sourceQty);
        },
        refundAppliedTax(item) {
            return RefundCalculations.applied(item.baseTax, item.qty, item.sourceQty);
        },
        refundMaxAmount(item) {
            return RefundCalculations.maxApplied(item.sourceAmount, item.qty, item.sourceQty);
        },
        refundMaxTax(item) {
            return RefundCalculations.maxApplied(item.sourceTax, item.qty, item.sourceQty);
        },
        // A typed value is the new full-line base (Work Order convention); the cell
        // re-renders showing the scaled applied value.
        onRefundAmountEntered(event, item) {
            const raw = event instanceof Event ? event.target?.value : event;
            const parsed = raw == null || raw === '' ? 0 : Number(raw);
            item.baseAmount = Number.isFinite(parsed) ? parsed : 0;
        },
        onRefundTaxEntered(event, item) {
            const raw = event instanceof Event ? event.target?.value : event;
            const parsed = raw == null || raw === '' ? 0 : Number(raw);
            item.baseTax = Number.isFinite(parsed) ? parsed : 0;
        },
        shipmentHasRefundable(saleShipment) {
            return (saleShipment.canRefundShipping === true)
                || (saleShipment.saleShippingProducts || []).some(
                    p => this.remainingRefundable(p) > 0
                );
        },
        refundRowClass(item) {
            if (!item || item.refundedQty == null) return '';
            if (item.refundedQty >= item.shippedQty && item.shippedQty > 0) {
                return 'text-muted opacity-50';
            }
            return '';
        },
        openRefundModal(saleShipment) {
            this.refundShipment = saleShipment;
            this.refundLines = (saleShipment.saleShippingProducts || [])
                .filter(p => this.remainingRefundable(p) > 0)
                .map(p => {
                    const remaining = this.remainingRefundable(p);
                    return {
                        saleItemId: p.saleItemId,
                        description: p.description,
                        skuProduct: p.skuProduct,
                        remaining: remaining,
                        // Denominator for the applied fraction (the fulfilled line qty).
                        sourceQty: p.shippedQty,
                        // Immutable source full-line values, for caps.
                        sourceAmount: p.extendedPrice,
                        sourceTax: p.taxTotal,
                        // Editable full-line bases, seeded from the source SaleFulfillmentItem.
                        baseAmount: p.extendedPrice,
                        baseTax: p.taxTotal,
                        // Default to refunding everything still refundable on the line.
                        qty: remaining
                    };
                });
            // Shipping defaults to the full refundable shipping amount + tax.
            this.refundShippingAmount = saleShipment.canRefundShipping ? (saleShipment.shippingTotal || 0) : 0;
            // Tax-exempt orders must not refund shipping tax even if the source carries a stale value (field is also disabled).
            this.refundShippingTax = (saleShipment.canRefundShipping && !this.webOrder.isTaxExempt) ? (saleShipment.shippingTax || 0) : 0;
            this.isRefundTaxBusy = false;
            this.$refs.refundModal.show();
        },
        refreshRefundTaxes() {
            this.$bvModal
                .msgBoxConfirm(
                    'This will refresh all tax values on the current screen, including overridden values.'
                )
                .then(ok => {
                    if (ok) {
                        this.doRefreshRefundTaxes();
                    }
                });
        },
        doRefreshRefundTaxes() {
            this.isRefundTaxBusy = true;
            const lines = this.refundLines
                .filter(l => l.qty > 0)
                .map(l => ({
                    saleItemId: l.saleItemId,
                    qty: l.qty,
                    amount: this.refundAppliedAmount(l)
                }));
            // Refresh includes shipping only when there's a shipping amount: the tax service needs
            // the amount as the base to recompute shipping tax. (processRefund also includes it for a
            // manually-entered tax-only shipping refund; that path isn't a tax-service recalculation.)
            const includeShipping =
                this.refundShipment.canRefundShipping && (this.refundShippingAmount || 0) > 0;
            axios
                .post('weborders/refreshtaxrefund', {
                    saleId: this.webOrder.saleId,
                    sourceSaleFulfillmentId: this.refundShipment.saleFulfillmentId,
                    lines: lines,
                    shippingAmount: includeShipping ? this.refundShippingAmount : null
                })
                .then(resp => {
                    const data = resp && resp.data ? resp.data : {};
                    (data.lines || []).forEach(rt => {
                        const line = this.refundLines.find(l => l.saleItemId === rt.saleItemId);
                        if (line) {
                            line.baseTax = RefundCalculations.baseFromApplied(
                                rt.tax,
                                line.qty,
                                line.sourceQty
                            );
                        }
                    });
                    if (data.shippingTax != null) {
                        this.refundShippingTax = data.shippingTax;
                    }
                })
                .finally(() => {
                    this.isRefundTaxBusy = false;
                });
        },
        async processRefund() {
            if (!(await this.$refs.refundForm.validate())) {
                return;
            }

            const items = this.refundLines
                .filter(l => l.qty > 0)
                .map(l => ({
                    saleItemId: l.saleItemId,
                    qty: l.qty,
                    amount: this.refundAppliedAmount(l),
                    tax: this.refundAppliedTax(l)
                }));

            const includeShipping =
                this.refundShipment.canRefundShipping &&
                ((this.refundShippingAmount || 0) > 0 || (this.refundShippingTax || 0) > 0);

            if (items.length === 0 && !includeShipping) {
                this.$appError('Select at least one item or shipping to refund.');
                return;
            }

            this.isRefundBusy = true;
            axios
                .post('weborders/processwebshipmentrefund', {
                    saleId: this.webOrder.saleId,
                    sourceSaleFulfillmentId: this.refundShipment.saleFulfillmentId,
                    refundItems: items,
                    refundShippingAmount: includeShipping ? this.refundShippingAmount : null,
                    refundShippingTax: includeShipping ? this.refundShippingTax : null
                })
                .then(resp => {
                    if (resp && resp.data.posAPIResult) {
                        this.$refs.refundModal.hide();
                        this.$appSuccess(
                            `Refund for '${this.webOrder.name}' processed successfully.`
                        );
                        this.loadData();
                    } else if (resp) {
                        this.$appError(
                            resp.data.failedMessage ||
                                'The refund could not be processed.'
                        );
                    }
                })
                .finally(() => {
                    this.isRefundBusy = false;
                });
        },
        async printPicklist() {
            let selectedIds = [this.webOrder.saleId];
            let apiUrl = `/weborders/exportPrintPickList`;

            this.isBusy = true;

            axios
                .post(
                    apiUrl,
                    {
                        ids: selectedIds,
                        unfulfilled: true
                    },
                    { responseType: 'blob' }
                )
                .then(result => {
                    if (result.data.size === 0) {
                        this.$appWarning('Nothing to pick, all products either fulfilled, cancelled, or backordered.')
                        return;
                    }
                    
                    downloadFileToBrowser(
                        result.data,
                        `Print Picklist`,
                        'application/pdf'
                    );

                    this.$appSuccess(
                            `Print picklist report generated successfully.`
                        )
                })
                .finally(() => {
                    this.isBusy = false;
                });
        }        
    },
    async mounted() {
        var currentlySelectedLocationId = await selectListOptionsDataContext.getSelectedLocationIdAsync();
        this.currentlySelectedLocationId = currentlySelectedLocationId;
        this.loadData();
    },
    components: {
        ProductMultiSelectQuickSearch,
        ARAccountsModal,
        DepartmentChargeModal
    }
};
</script>

<style scoped lang="scss">
@import "@/styles/app/common/variables.scss";
:deep(.noWrap ) {
    white-space: nowrap;
}

:deep(.tcw100 ) {
    width: 100px;
}

:deep(.tcw200 ) {
    width: 200px;
}
.redColor {
    color: red;
}

.no-top-border :deep(table),
.no-top-border :deep(table th),
.no-top-border :deep(table td) {
    border-top: none !important;
}

.refund-card {
    border-left: 3px solid var(--bs-danger, #dc3545);
}
</style>